const elements = {
	quickBookerFab: document.getElementById("js-quick-booker-fab"),
	quickBookerMenu: document.getElementById("js-quick-booker-menu"),
};

if (elements?.quickBookerFab) {
	elements?.quickBookerFab?.addEventListener("click", () => {
		if (elements?.quickBookerMenu) {
			elements?.quickBookerMenu.setAttribute("aria-expanded", "true");
		}
	});
}
